// Nannyou — Version Frontend
// Format: V{MAJOR}.{BUILD} → V1.001, V1.002, etc.
// Auto-incremented by GitHub Actions on each deployment
// Generated from environment-specific version file

const MAJOR_VERSION = "1";
const BUILD_NUMBER = "002";  // Auto-incremented by CI/CD
export const APP_VERSION = `V${MAJOR_VERSION}.${BUILD_NUMBER}`;
